module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding-left": "10px"
    },
    attrs: {
      "id": "evalContent"
    }
  }, [_vm._l((_vm.trainList), function(item) {
    return [_c('div', {
      staticClass: "evalItem"
    }, [_c('div', {
      staticClass: "board pointer",
      on: {
        "click": function($event) {
          _vm.showDetail(item, 0)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.address + item.image
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "boardName"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('level', {
      attrs: {
        "level": item.level
      }
    })], 1)]
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "container"
    }
  }, [(_vm.showModal) ? _c('trainContentmodal', {
    attrs: {
      "showInput": _vm.showInput
    }
  }) : _vm._e()], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fe94252a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/service/train/trainContent.vue
// module id = 1036
// module chunks = 2